app.controller("AddMessageContainer", ["$scope", "params", "LecturerService", "ExamsService", "Session", "$uibModalInstance",
    function ($scope, params, LecturerService, ExamsService, Session, $uibModalInstance) {
        $scope.subjectName = params.subjectName;
        $scope.group = params.group;
        $scope.sessionType = params.sessionType;
        $scope.text = params.group&&params.group.lastPost ? params.group.lastPost.text : '';
        $scope.type = params.type;
        $scope.zoomUrl = params.zoomUrl;
        $scope.supportUrl = params.supportUrl;
        $scope.scheduleUrl = params.scheduleUrl;
        $scope.lecturerId = params.lecturerId;
        $scope.consultation = null;
        $scope.error = {
            show: false,
            text: ''
        };

        if($scope.lecturerId) {
            LecturerService.getConsultations([$scope.lecturerId]).then(function (result) {
                if (result && result[0]) {
                    $scope.consultation = result[0];
                    $scope.text = result[0].value;
                }
            });
        }

        $scope.save = function () {
            if($scope.supportUrl) {
                $scope.editSupportUrl($scope.supportUrl);
            } else if ($scope.scheduleUrl) {
                $scope.editScheduleUrl($scope.scheduleUrl)
            } else if ($scope.zoomUrl) {
                $scope.setUrls();
            } else if ($scope.lecturerId) {
                $scope.editConsultations();
            } else {
                $scope.updatePost();
            }
        };

        $scope.updatePost = function () {
            LecturerService.post({
                groupId: $scope.group._id,
                text: $scope.text
            }).then(function (result) {
                if (result) {
                    $uibModalInstance.close("success");
                }
            });
        };

        $scope.setUrls = function () {
            if($scope.group.zoomUrl.length&&$scope.group.zoomUrl.slice(0, 5) !== 'https' ||
                $scope.group.zoomUrl.archiveUrl&&$scope.group.archiveUrl.slice(0, 5) !== 'https') {
                $scope.error.text = `ბმული უნდა იწყებოდეს "https://"-ით !`
                $scope.error.show = true;
            } else {
                $scope.error.show = false;
                Session.setZoomUrl({
                    _id: $scope.group._id,
                    zoomUrl: $scope.group.zoomUrl,
                    archiveUrl: $scope.group.archiveUrl
                }).then(function (result) {
                    if (result) {
                        $uibModalInstance.close("success");
                    }
                })
            }
        };

        $scope.editSupportUrl = function () {
            if($scope.supportUrl.length&&$scope.supportUrl.slice(0, 5) !== 'https') {
                $scope.error.text = `ბმული უნდა იწყებოდეს "https://"-ით !`
                $scope.error.show = true;
            } else {
                ExamsService.editSupportUrl({
                    value: $scope.supportUrl
                }).then(function (result) {
                    if (result) {
                        $uibModalInstance.close("success");
                    }
                })
            }
        };

        $scope.editScheduleUrl = function () {
            if($scope.scheduleUrl.length&&$scope.scheduleUrl.slice(0, 5) !== 'https') {
                $scope.error.text = `ბმული უნდა იწყებოდეს "https://"-ით !`
                $scope.error.show = true;
            } else {
                $scope.error.show = false;
                ExamsService.editScheduleUrl({
                    value: $scope.scheduleUrl
                }).then(function (result) {
                    if (result) {
                        $uibModalInstance.close("success");
                    }
                })
            }
        };

        $scope.editConsultations = function () {
            if($scope.consultation) {
                LecturerService.editConsultations($scope.consultation._id, $scope.text).then(function (result) {
                    if (result) {
                        $uibModalInstance.close("success");
                    }
                })
            } else {
                LecturerService.setConsultations($scope.lecturerId, $scope.text).then(function (result) {
                    if (result) {
                        $uibModalInstance.close("success");
                    }
                })
            }
        }

        $scope.close = function () {
            $uibModalInstance.dismiss();
        };
    }
]);
